import DepositData from "../../entities/DepositData";
import PensionData from "../../entities/PensionData";
import RedemptionRightData from "../../entities/RedemptionRightData";
import UserFund from "../../entities/UserFund";

export const setShowAmitMobile = (showAmitFund: boolean) => {
  return {
    type: SET_AMIT_FUND_MOBILE,
    payload: showAmitFund,
  };
};

export const setShowGimlaiMobile = (showGimlaiFund: boolean) => {
  return {
    type: SET_GIMLAI_FUND_MOBILE,
    payload: showGimlaiFund,
  };
};

export const setActiveFund = (fund: UserFund) => {
  return {
    type: SET_ACTIVE_FUND,
    payload: fund,
  };
};

export const setPensionDataRedux = (data: PensionData) => {
  return {
    type: SET_PENSION_DATA_REDUX,
    payload: data,
  };
};

export const setRedemptionRightDataRedux = (data: RedemptionRightData) => {
  return {
    type: SET_REDEMPTION_RIGHT_DATA_REDUX,
    payload: data,
  };
};


export const setSalaryDataRedux = (data: any) => {
  return {
    type: SET_SALARY_DATA_REDUX,
    payload: data,
  };
};


export const setIsDoc = (data: boolean) => {
  return {
    type: SET_ISDOC,
    payload: data,
  };
};


export const setRightsPerEmpRedux = (data: RedemptionRightData) => {
  return {
    type: SET_RIGHT_PER_EMP_REDUX,
    payload: data,
  };
};


export const setFundCount = (data: number) => {
  return {
    type: SET_FUND_COUNT,
    payload: data,
  };
};


export const SET_RIGHT_PER_EMP_REDUX = "SET_RIGHT_PER_EMP_REDUX";
export const SET_SALARY_DATA_REDUX = "SET_SALARY_DATA_REDUX";
export const SET_ISDOC = "SET_ISDOC";
export const SET_REDEMPTION_RIGHT_DATA_REDUX = "SET_REDEMPTION_RIGHT_DATA_REDUX";
export const SET_AMIT_FUND_MOBILE = "SET_AMIT_FUND_MOBILE";
export const SET_PENSION_DATA_REDUX = "SET_PENSION_DATA_REDUX";
export const SET_GIMLAI_FUND_MOBILE = "SET_GIMLAI_FUND_MOBILE";
export const SET_ACTIVE_FUND = "SET_ACTIVE_FUND";
export const SET_FUND_COUNT = "SET_FUND_COUNT";

